import React from 'react';
import PropTypes from 'prop-types';
import parse, { domToReact } from 'html-react-parser';
import _get from 'lodash/get';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import useSiteCopySelector from 'components/useSiteCopySelector';

const useStyles = makeStyles(theme => ({
  wrapper: {
    backgroundColor: '#01619B',
    paddingTop: 81,
    paddingBottom: 81,
    position: 'relative',
  },
  container: {
    width: '80%',
    maxWidth: 1080,
    margin: 'auto',
  },
  h1: {
    fontFamily: 'PoppinsSemiBold',
    fontWeight: '600',
    fontSize: 35,
    lineHeight: '1.1em',
    paddingBottom: 37,
    color: '#FFFFFF',
    textAlign: 'center',
  },
  quoteContainer: {
    display: 'flex',
    paddingTop: 27,
    paddingBottom: 27,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  imageWrapper: {
    width: '29.667%',
    marginRight: '5.5%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      margin: '0 auto 30px',
    },
  },
  image: {
    width: '100%',
    height: 'auto',
    maxHeight: 1000,
    objectFit: 'contain',
  },
  quoteWrapper: {
    width: '64.833%',
    margin: 'auto 0',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      margin: 0,
    },
  },
  quote: {
    fontFamily: 'OpenSansRegular',
    fontSize: 30,
    fontWeight: '500',
    lineHeight: '1.4em',
    color: '#FFFFFF',
    paddingBottom: 47,
    '& > a': {
      color: '#2EA3F2',
      '-webkit-appearance': 'none',
    },
  },
  author: {
    fontFamily: 'OpenSansRegular',
    fontSize: 14,
    fontWeight: '500',
    lineHeight: '1.7em',
    color: '#FFFFFF',
    '& > b': {
      fontFamily: 'OpenSansBold',
    },
  },
}));

function QuoteSection({ onPageExit }) {
  const [solutionsSiteCopy] = useSiteCopySelector(['solutions-homepage']);
  const config = _get(solutionsSiteCopy, 'pageCopy.quote-section', {});
  const classes = useStyles();

  const options = {
    replace: domNode => {
      if (domNode.name === 'a') {
        return (
          <a
            role="link"
            tabIndex={0}
            onClick={() => onPageExit(domNode.attribs.href, 'quote-section')}
            {...domNode.attribs}
          >
            {domToReact(domNode.children)}
          </a>
        );
      }
      return domToReact(domNode);
    },
  };

  return (
    <section id="quote-section">
      <div className={classes.wrapper}>
        <div className={classes.container}>
          <Typography className={classes.h1}>{config.title}</Typography>
          <div className={classes.quoteContainer}>
            <div className={classes.imageWrapper}>
              <img
                className={classes.image}
                src={config.quote.image}
                alt=""
                title=""
              />
            </div>
            <div className={classes.quoteWrapper}>
              <Typography className={classes.quote}>
                {parse(config.quote.text, options)}
              </Typography>
              <Typography className={classes.author}>
                {parse(config.quote.label, options)}
              </Typography>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

QuoteSection.propTypes = {
  onPageExit: PropTypes.func,
};

export default QuoteSection;
